module.exports = __webpack_public_path__ + "static/media/ic-single-let-stance.e640383f.svg";